import { PageLocatorMap } from '../types/PageLocatorMap';

export const applicationUpdatePage = {
  alert: {
    error: 'application-update.alert.error',
    signInLink: 'application-update.alert.signin-link',
    signUpLink: 'application-update.alert.signup-link',
  },
  footer: {
    root: 'application-update.footer',
  },
  form: {
    h1: 'application-update.form.heading1',
    h2: 'application-update.form.heading2',
    phoneInput: 'application-update.form.phone-input',
    phoneInputError: 'application-update.form.phone-error',
    root: 'application-update.form.root',
    submitButton: 'application-update.form.submit-button',
  },
  header: {
    root: 'application-update.header',
  },
} as const satisfies PageLocatorMap;
